import React from 'react'

import { platforms } from '../../constants'
import './Platforms.css'

const Platforms = ({parent_platforms}) => {
  return (
    <div className='platforms'>
            {parent_platforms.map((item, index) => {
              return (
                <div key={index}>{platforms.platforms[item.platform.slug]}</div>
              )
            })}
          </div>
  )
}

export default Platforms